import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getServices, finishSetMerchant } from '../../store/merchant/actions';

export default function withMerchant(WrappedComponent) {
  const mapStateToProps = state => ({
    merchant: state.merchant.merchant,
    isLoadingMerchant: state.merchant.isLoading,
  });

  const mapDispatchToProps = dispatch => ({
    getServices: () => dispatch(getServices()),
    finishSetMerchant: () => dispatch(finishSetMerchant()),
  });
  /* eslint-disable react/prop-types */
  class MerchantContainer extends PureComponent {
    componentDidMount() {
      this.props.getServices();
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }
  /* eslint-enable */

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(MerchantContainer);
}



// WEBPACK FOOTER //
// ./src/containers/Merchant/index.js